import {PLANAR_SNAPSHOTS} from 'constants/pullable-types.js';
export const findEffect = (id, sequencerEngine) => {
    for (let sub of sequencerEngine.subSequences) {
        for (let track of sub.tracks) {
            let effects = [... track.effects, ...track.midiEffects.effects, ...track.liveEffects.effects];
            for (let effect of effects) {
                if (effect.effects) {
                    effects = [... effects, ...effect.effects];
                }
            }
            let effect = effects.find(x => x.id === id);
            if (effect) {
                return effect;
            }
        }
        let fx = sub.midiEffects.effects.find(x => x.id === id);
        if (fx) {
            return fx;
        }
    }
    return undefined;
}

export const findInstrumentPart = (id, type, sequencerEngine) => {
    for (let sub of sequencerEngine.subSequences) {
        for (let track of sub.tracks) {
            if (type === PLANAR_SNAPSHOTS) {
                // find it
                let midiFx = [];
                for (let fx of track.midiEffects.effects) {
                    if (fx.effects) {
                        midiFx = [... midiFx, ... fx.effects];
                    } else {
                        midiFx.push(fx);
                    }
                }
                let effectFound = midiFx.find(e => e.snapshotComponent &&
                                       e.snapshotComponent.id === id);
                if (effectFound) {
                    return {
                        type,
                        track: track,
                        instrument: effectFound.snapshotComponent,
                        effect: effectFound,
                    };
                }
            }
            if (track.instrument && track.instrument.id === id) {
                return {
                    type,
                    track: track,
                    instrument: track.instrument
                };
            }
        }
    }
    return undefined;
};
